import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_SCHEMAS_BY_NAME, GET_SCHEMAS_BY_NAME_ERROR, GET_SCHEMAS_BY_NAME_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getSchemasByName({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/schemas/${payload?.params?.name}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SCHEMAS_BY_NAME_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SCHEMAS_BY_NAME_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SCHEMAS_BY_NAME_ERROR, payload: error });
  }
}

export function* watchGetSchemasByName() {
  yield takeEvery(GET_SCHEMAS_BY_NAME, getSchemasByName);
}

function* getSchemasByNameSaga() {
  yield all([fork(watchGetSchemasByName)]);
}

export default getSchemasByNameSaga;
